import { render, staticRenderFns } from "./NavigatorItem.vue?vue&type=template&id=356a2a30&"
import script from "./NavigatorItem.vue?vue&type=script&lang=js&"
export * from "./NavigatorItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports